import React from 'react';
import styled from 'styled-components';
import { TInfoClient } from '../../store/users/types';
import { EIcons } from '../../utils/globatTypes';

interface SearchUsersProps {
  users: TInfoClient[] | null | undefined;
  onChange: (user: TInfoClient[]) => void;
}

export const SearchUsers: React.FC<SearchUsersProps> = React.memo(({ users, onChange }) => {
  const [value, setValue] = React.useState('');

  const searchUser = (search: string) => {
    setValue(search);
    if (search.length === 0 && users) {
      onChange(users);
    }
    if (users) {
      const items = users.filter((item) => {
        if (item.fio.toLowerCase().includes(search.toLowerCase())) {
          return true;
        }
        return false;
      });
      onChange(items);
    }
  };

  return (
    <WrapInput>
      <Input type="text" value={value} onChange={(e) => searchUser(e.currentTarget.value)} placeholder="Пошук учасників" />
      <SearchIcon>
        <i className={EIcons.search} />
      </SearchIcon>
    </WrapInput>
  );
});

const WrapInput = styled.div`
  position: relative;
  width: 100%;
  color: white;
  background: white;
  margin: 10px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  border: 1px solid rgba(26, 130, 197, 1);
`;

const SearchIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  color: rgba(26, 130, 197, 1);
  height: 100%;
  font-size: 20px;
  cursor: pointer;
`;

const Input = styled.input`
  width: 100%;
  height: 100%;
  outline: none;
  border: none;
  padding: 10px;
`;
